module.exports = __webpack_public_path__ + "static/media/bite.b7e1e091.mp3";